module.exports = __webpack_public_path__ + "assets/img/BodyLux-w960.c4584daf.jpg";